import { Typography, SxProps, Theme, TypographyProps } from '@mui/material';

type Props = {
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
  props?: TypographyProps;
};

export default function DashboardDescription({ children, sx, props }: Props) {
  return (
    <Typography sx={{ fontSize: 12, fontWeight: 600, opacity: 0.9, ...sx }} {...props}>
      {children}
    </Typography>
  );
}
